/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "../ColorsProvider";
import prefixStyles, { type StylesObject } from "../utils/prefixStyles";
import Slider from "../Slider";
import Theme from "../Theme";
import NumericUpDownPicker from "../NumericUpDownPicker";

type Props = {
  value: number,
  hasOffState: boolean,
  min: number,
  max: number,
  step: number,
  unit?: ?string,
  label?: ?React.Node,
  onDown?: ?() => void,
  onUp?: ?() => void,
  onSliderChange?: ?(value: number) => void,
  onDragStart?: ?() => void,
  onDragEnd?: ?() => void,
  formatter?: ?(value: number) => string,
  style?: ?StylesObject,
  valueStyle?: ?StylesObject,
  upButtonStyle?: ?StylesObject,
  downButtonStyle?: ?StylesObject,
  sliderStyle?: ?StylesObject,
  isHeat?: ?boolean,
  isCool?: ?boolean,
  "aria-controls"?: ?string,
  colors: ColorSet,
};

class DumbPrecisionSlider extends React.Component<Props> {
  static defaultProps = {
    step: 1,
  };

  render() {
    const {
      value,
      hasOffState,
      min,
      max,
      step,
      unit,
      label,
      onDown,
      onUp,
      onSliderChange,
      onDragStart,
      onDragEnd,
      formatter,
      style,
      valueStyle,
      upButtonStyle,
      downButtonStyle,
      isHeat,
      isCool,
      sliderStyle,
      "aria-controls": ariaControls,
      colors,
    } = this.props;
    const styles = {
      wrapper: {
        outline: "none",
        ...style,
      },
      label: prefixStyles({
        color: colors.LABEL,
        fontSize: 16,
        userSelect: "none",
      }),
      controlsWrapper: prefixStyles({
        display: "flex",
      }),
      value: prefixStyles({
        fontSize: 35,
        userSelect: "none",
        ...valueStyle,
      }),
      slider: {
        marginTop: 10,
        marginLeft: 15,
        marginRight: 15,
        ...Theme.Styles.flexStretch,
        ...sliderStyle,
      },
      upButton: {
        ...upButtonStyle,
      },
      downButton: {
        marginRight: "0.4em",
        ...downButtonStyle,
      },
    };

    return (
      <div
        data-component-name="PrecisionSlider"
        tabIndex="0"
        style={styles.wrapper}
      >
        {label && <div style={styles.label}>{label}</div>}
        <div style={styles.controlsWrapper}>
          <span style={styles.value}>
            {formatter ? formatter(value) : `${value}${unit || ""}`}
          </span>
          <Slider
            hasOffState={hasOffState}
            style={styles.slider}
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={onSliderChange}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            isHeat={isHeat}
            isCool={isCool}
          />
          <NumericUpDownPicker
            onUp={onUp}
            onDown={onDown}
            upDisabled={value + step > max}
            downDisabled={value - step < min}
            upButtonStyle={styles.upButton}
            downButtonStyle={styles.downButton}
            aria-controls={ariaControls}
          />
        </div>
      </div>
    );
  }
}

export default withColorsProvider(DumbPrecisionSlider);



// WEBPACK FOOTER //
// ../nx-components/src/PrecisionSlider/DumbPrecisionSlider.jsx